/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ProcedureBloodProducts from './procedure-blood-products';
import ProcedureBloodProductsDetail from './procedure-blood-products-detail';
import ProcedureBloodProductsUpdate from './procedure-blood-products-update';
import ProcedureBloodProductsDeleteDialog from './procedure-blood-products-delete-dialog';

const ProcedureBloodProductsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ProcedureBloodProducts />} />
    <Route path="new" element={<ProcedureBloodProductsUpdate />} />
    <Route path=":id">
      <Route index element={<ProcedureBloodProductsDetail />} />
      <Route path="edit" element={<ProcedureBloodProductsUpdate />} />
      <Route path="delete" element={<ProcedureBloodProductsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ProcedureBloodProductsRoutes;
